import { useState } from "react";
import { Layout } from "antd";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

const { Sider, Content } = Layout;

const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      <Layout style={{ height: "100vh" }}>
        <Navbar
          collapsed={collapsed}
          onToggleSidebar={() => setCollapsed(!collapsed)}
        />

        <Layout>
          <Sider
            style={{ background: "#fff" }}
            trigger={null}
            collapsible
            collapsed={collapsed}
          >
            <Sidebar collapsed={collapsed} />
          </Sider>
          <Content
            style={{
              overflowY: "scroll",
              overflowX: "hidden",
              minHeight: 280,
              background: "#f5f6fa",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default DashboardLayout;
